/**
 * @file 号码认证
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {
    GET_AUTH,
    GET_AUTH_EDIT,
    GET_USER_INFO,
    GET_CHECK_PHONE,
    GET_GET_DETAIL,
    GET_SEND_CODE,
    GET_DELEGATION_AUTH,
    GET_DELEGATION_TYPE,
    GET_DELEGATION_SUBMIT,
    GET_CHECK_COMPANY_NAME,
    GET_ENTITY,
    GET_FLASH_NUM
} from './ActionTypes';

export function fetchUserInfo(dispatch) {
    return rcAjax('GET', '/api/v1/user/info', {}, {}, (data = {}) => {
        dispatch({type: GET_USER_INFO, data: data.data});
    });
}

export function fetchAuth(dispatch, params) {
    let url = `/api/v1/auth?type=${params.type}&step=${params.step}`;
    delete params.type;
    delete params.step;
    return rcAjax('POST', url, {}, params, data => {
        dispatch({type: GET_AUTH, data: data.data});
    });
}

export function fetchCheckphone(dispatch, params) {
    return rcAjax('POST', '/api/v1/check', {}, params, data => {
        dispatch({type: GET_CHECK_PHONE, data: data.data});
    });
}

export function fetchGetDetail(dispatch, params) {
    return rcAjax('POST', '/api/v1/auth/getDetail', {}, params, data => {
        dispatch({type: GET_GET_DETAIL, data: data.data});
    });
}

export function fetchDelete(dispatch, params) {
    return rcAjax('POST', '/api/v1/auth/delete', {}, params, data => {
        dispatch({type: 'GET_GET_DELETE', data: data.data});
    });
}

export function fetchAttestSendCode(dispatch, params) {
    // type 1email 2phone verity=val
    return rcAjax('POST', '/api/v1/sms/anonymous', {}, params, data => {
        dispatch({type: GET_SEND_CODE, data: data.data});
    });
}
export function fetchSendCode(dispatch, params) {
    // type 1email 2phone verity=val
    return rcAjax('POST', '/api/v1/code/send', {}, params, data => {
        dispatch({type: GET_SEND_CODE, data: data.data});
    });
}

export function fetchSmsCode(dispatch, params) {
    return rcAjax('POST', '/api/v1/sms/send', {}, params, data => {
        dispatch({type: GET_SEND_CODE, data: data.data});
    });
}

export function fetchAuthEdit(dispatch, params) {
    return rcAjax('POST', '/api/v1/auth/edit', {}, params, data => {
        dispatch({type: GET_AUTH_EDIT, data: data.data});
    });
}
export function fetchDelegationAuth(dispatch, params) {
    return rcAjax('POST', '/api/v1/cloud/delegation/auth', {}, params, data => {
        dispatch({type: GET_DELEGATION_AUTH, data: data.data});
    });
}
export function fetchDelegationType(dispatch, params) {
    return rcAjax('POST', '/api/v1/cloud/delegation/type', {}, params, data => {
        dispatch({type: GET_DELEGATION_TYPE, data: data.data});
    });
}
export function fetchDelegationSubmit(dispatch, params) {
    return rcAjax('POST', '/api/v1/cloud/delegation/submit', {}, params, data => {
        dispatch({type: GET_DELEGATION_SUBMIT, data: data.data});
    });
}
export function fetchCheckCompanyName(dispatch, params) {
    return rcAjax('POST', '/api/v1/cloud/delegation/query/v2', {}, params, data => {
        dispatch({type: GET_CHECK_COMPANY_NAME, data: data.data});
    });
}

export function fetchEntity(dispatch, params) {
    return rcAjax('POST', '/api/v1/entity', {}, params, data => {
        dispatch({type: GET_ENTITY, data: data.data});
    });
}

export function fetchFlashNum(dispatch) {
    return rcAjax('GET', '/api/v1/cloud/delegation/count', {}, {}, (data = {}) => {
        dispatch({type: GET_FLASH_NUM, data: data.data});
    });
}